import { View } from '../../../../entities/view';
import { IViewGroup } from '../../../../entities/view-group';

import { sortBySortOrder } from '@ml/common';
import { AnimationState } from '../../../animations';
import { Tour } from '../../../../entities/tour';

export class MenuAccordionVM {
  Id: number;
  Name: string;
  IsOpen = false;
  ChildItems: MenuAccordionItemVM[] = [];
  SortOrder: number;
  AnimationState = '';

  constructor() {
    this.AnimationState =
      typeof screen !== 'undefined' && screen?.orientation?.type === 'landscape-primary'
        ? AnimationState.CollapsedWidth
        : AnimationState.CollapsedHeight;
  }

  static CreateFromViewGroup(vg: IViewGroup, allViews: View[]) {
    const vm = new MenuAccordionVM();
    vm.Id = vg.PanoViewGroupId;
    vm.Name = vg.Name;
    vm.SortOrder = vg.SortOrder;

    vm.ChildItems = vg.ChildViewIds.map(id => {
      const v = allViews.find(x => x.ViewId === id);
      if (v)
        return new MenuAccordionItemVM(
          v.ViewId,
          v.Name,
          vg.CustomData?.ChildViewsSortOrderById?.indexOf(id)
        );
    })
      .filter(Boolean)
      .sort(sortBySortOrder);

    return vm;
  }

  static CreateFromTours(name: string, tours: Tour[]) {
    const vm = new MenuAccordionVM();
    vm.Id = -1;
    vm.Name = name;
    vm.SortOrder = 0;

    vm.ChildItems = tours
      .map((tour: Tour, index: number) => new MenuAccordionItemVM(tour.TourId, tour.Name, index))
      .filter(Boolean)
      .sort(sortBySortOrder);

    return vm;
  }

  getSelectedOption(): MenuAccordionItemVM {
    return this.ChildItems.find(o => o.IsSelected);
  }
}

export class MenuAccordionItemVM {
  constructor(
    public Id: number,
    public Name: string,
    public SortOrder: number,
    public IsSelected = false
  ) {}
}
